import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container, Divider, Paper, Typography } from '@mui/material'
import {
  CheckCircle as CheckCircleIcon,
  ErrorOutline as ErrorOutlineIcon,
  HourglassEmpty as HourglassIcon,
  LinkOff as LinkOffIcon,
} from '@mui/icons-material'
import { t } from 'i18next'

const T = 'YAPPY_PAYMENT_T'

const STATUS_CONFIG = {
  confirmed: {
    Icon: CheckCircleIcon,
    iconBg: 'rgba(46, 125, 50, 0.12)',
    iconColor: '#2e7d32',
    borderColor: '#4caf50',
    titleKey: `${T}.CONFIRMED_TITLE`,
    hintKey: `${T}.CONFIRMED_BODY`,
  },
  expired: {
    Icon: HourglassIcon,
    iconBg: 'rgba(255, 222, 32, 0.15)',
    iconColor: '#b07d00',
    borderColor: '#ffde20',
    titleKey: `${T}.EXPIRED_TITLE`,
    hintKey: `${T}.EXPIRED_HINT`,
  },
  not_found: {
    Icon: LinkOffIcon,
    iconBg: 'rgba(255, 222, 32, 0.15)',
    iconColor: '#b07d00',
    borderColor: '#ffde20',
    titleKey: `${T}.NOT_FOUND_TITLE`,
    hintKey: `${T}.NOT_FOUND_HINT`,
  },
  error: {
    Icon: ErrorOutlineIcon,
    iconBg: 'rgba(255, 42, 64, 0.1)',
    iconColor: '#cc0018',
    borderColor: '#ff2a40',
    titleKey: `${T}.LOAD_ERROR_TITLE`,
    hintKey: `${T}.LOAD_ERROR_HINT`,
  },
  failed: {
    Icon: ErrorOutlineIcon,
    iconBg: 'rgba(255, 42, 64, 0.1)',
    iconColor: '#cc0018',
    borderColor: '#ff2a40',
    titleKey: `${T}.FAILED_TITLE`,
    hintKey: `${T}.FAILED_HINT`,
  },
}

function YappyStatusScreen({ variant, message }) {
  const cfg = STATUS_CONFIG[variant] ?? STATUS_CONFIG.error
  const { Icon } = cfg

  return (
    <Box
      className="yappy-payment-page"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      px={2}
      py={4}>
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            borderTop: `4px solid ${cfg.borderColor}`,
          }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              bgcolor: cfg.iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}>
            <Icon sx={{ fontSize: 36, color: cfg.iconColor }} />
          </Box>

          <Typography variant="h5" gutterBottom sx={{ fontSize: '1.75rem' }}>
            {t(cfg.titleKey)}
          </Typography>

          {message && (
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{ mb: 3, fontSize: '1.125rem' }}>
              {message}
            </Typography>
          )}

          <Divider sx={{ mb: 3 }} />

          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontSize: '1rem' }}>
            {t(cfg.hintKey)}
          </Typography>
        </Paper>
      </Container>
    </Box>
  )
}

YappyStatusScreen.propTypes = {
  variant: PropTypes.oneOf([
    'confirmed',
    'expired',
    'not_found',
    'error',
    'failed',
  ]).isRequired,
  message: PropTypes.string,
}

export default YappyStatusScreen
